<div class="share-link">
  <a
    [href]="facebookShareLink"
    class="facebook"
    target="_blank"
    rel="noopener noreferrer"
    (click)="click('facebook')"
    [style.backgroundColor]="iconBackgroundColor"
    aria-label="Share on Facebook"
  >
  </a>
  <a
    [href]="twitterShareLink"
    class="twitter"
    target="_blank"
    rel="noopener noreferrer"
    (click)="click('twitter')"
    [style.backgroundColor]="iconBackgroundColor"
    aria-label="Share on Twitter"
  >
  </a>
  <a
    [href]="linkedinShareLink"
    class="linkedin"
    target="_blank"
    rel="noopener noreferrer"
    (click)="click('linkedin')"
    [style.backgroundColor]="iconBackgroundColor"
    aria-label="Share on LinkedIn"
  >
  </a>
  <button
    (click)="copyLink()"
    aria-label="Copy article link to clipboard"
    class="copy-link"
    [style.backgroundColor]="iconBackgroundColor"
  ></button>

  <div class="notification" *ngIf="showSharingNotification">{{ sharingNotification$ | async }}</div>
</div>
